import { Type } from "class-transformer";
import { EnaioDocument } from "src/modules/enaio/shared/EnaioDocument";
import { Utils } from "src/modules/utils/shared/utils";
import { EnaioFrontendColumn } from "./enaio-frontend-column.model";
import { EnaioFrontendSortColumn } from "./enaio-frontend-sort-column.model";
import { EnaioFrontendField } from "./enaio-frontend-field";
import { MainAppService } from "src/modules/app-template/services/main-app.service";
import { OrdinaryObjectNumber } from "src/modules/utils/shared/ordinary-object.model";
import { EnaioDocumentResult } from "./enaio-document-result.model";

export class EnaioDocumentFrontendResult {
    defId = "";
    name = "";
    nameSingular = "";
    icon = "";
    boxColor = "";
    hasDocuments = true;
    useSearchBar = false;
    searchBarLabel = "";
    @Type(() => EnaioFrontendField)
    searchFields: EnaioFrontendField[];
    canUpload = false;
    displayObjectTypeColumn = false;
    resultCount = 0;
    childDefId = "";
    parentDocument: EnaioDocument;
    parentId = "";
    parentName = "";
    parentObjectName = "";
    toStringTemplate = "";
    showMetaData = true;
    anonymousOnly = false;
    useSeenMarker = false;
    returnRemarkObjects = false;
    @Type(() => EnaioFrontendColumn)
    columns: EnaioFrontendColumn[] = [];
    @Type(() => EnaioFrontendSortColumn)
    sortColumns: EnaioFrontendSortColumn[] = [];
    @Type(() => EnaioDocumentResult)
    documents: EnaioDocumentResult[] = [];
 
    getTitle(document: EnaioDocument): string {
        return Utils.isNoe(this.toStringTemplate) ? this.name + " " + document.id : Utils.getTemplateFunction(this.toStringTemplate)(document.getMetaDataMap());
    }

    translate(app: MainAppService): void {        
        this.name = app.t("documents.frontendDefs." + this.defId + ".name", null, this.name);
        this.nameSingular = app.t("documents.frontendDefs." + this.defId + ".nameSingular", null, this.nameSingular);
        for (let col of this.columns) {
            if (this.documents != null && app.tRegexHas("documents.frontendDefs." + this.defId + ".columnContentTranslation." + col.title)) {
                for (let doc of this.documents) {
                    let field = doc.columns[col.title];
                    if (field != null) {
                        doc.columns[col.title] = app.tRegex("documents.frontendDefs." + this.defId + ".columnContentTranslation." + col.title, field);
                    }
                }
            }
            col.title = app.t("documents.frontendDefs." + this.defId + ".columns." + col.title, null, col.title);
        }
    }
}
